import React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';

const HomeContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  background-color: #f5f5f5;
  padding: 20px;
`;

const Title = styled.h1`
  font-size: 3rem;
  color: #333;
  margin-bottom: 20px;
  text-align: center;
`;

const Description = styled.p`
  font-size: 1.2rem;
  color: #555;
  max-width: 600px;
  text-align: center;
  margin-bottom: 30px;
`;

const StartButton = styled(Link)`
  background-color: #4caf50;
  color: white;
  padding: 15px 30px;
  font-size: 1.2rem;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  text-decoration: none;
  transition: background-color 0.3s;

  &:hover {
    background-color: #45a049;
  }
`;

const Home = () => {
  return (
    <HomeContainer>
      <Title>Flag Quiz Challenge</Title>
      <Description>
        Test your knowledge of world flags! This quiz uses the official UN list of country flags.
        How many can you identify correctly?
      </Description>
      <StartButton to="/settings">Start Quiz</StartButton>
    </HomeContainer>
  );
};

export default Home;
